import { createAction } from "@reduxjs/toolkit";

import { CompletedStatus } from "../../types";

const ACTION_PREFIX = "COMPLETE_STATUSES";

export const setCompleteStatuses = createAction<CompletedStatus[]>(`${ACTION_PREFIX}/SET`);
